import type { ReactNode } from 'react'
import './onboarding.css'
import { OnboardingStepData } from './tour.types'

const pad = (value: number) => String(value).padStart(2, '0')

type OnboardingTooltipProps = {
  index: number
  size: number
  title?: ReactNode
  content?: ReactNode
  data?: OnboardingStepData
  labels: {
    back: string
    next: string
    skip: string
    finish: string
    tryThis: string
  }
  onBack: () => void
  onNext: () => void
  onSkip: () => void
}

export const OnboardingTooltip = ({
  index,
  size,
  title,
  content,
  data,
  labels,
  onBack,
  onNext,
  onSkip,
}: OnboardingTooltipProps) => {
  const current = index + 1
  const isLastStep = index >= size - 1
  const progress = Math.round((current / size) * 100)

  return (
    <div className="ob-tip">
      <div className="ob-tip-top">
        <div className="ob-tip-meta">
          {data?.chapter ? (
            <span className="ob-tip-chapter">{data.chapter}</span>
          ) : null}
          <span className="ob-tip-kicker">
            {pad(current)} / {pad(size)}
          </span>
        </div>
        <button
          type="button"
          className="ob-tip-skip"
          onClick={(event) => {
            event.preventDefault()
            event.stopPropagation()
            onSkip()
          }}
        >
          {labels.skip}
        </button>
      </div>
      <div className="ob-tip-track" aria-hidden>
        <span style={{ width: `${progress}%` }} />
      </div>
      {title ? <h2 className="ob-tip-title">{title}</h2> : null}
      <div className="ob-tip-body">{content}</div>
      {data?.hint ? (
        <div className="ob-tip-hint">
          <span className="ob-tip-hint-label">{labels.tryThis}</span>
          <p>{data.hint}</p>
        </div>
      ) : null}
      <div className="ob-tip-actions">
        {index > 0 ? (
          <button
            type="button"
            className="ob-tip-btn ob-tip-btn--ghost"
            onClick={(event) => {
              event.preventDefault()
              event.stopPropagation()
              onBack()
            }}
          >
            {labels.back}
          </button>
        ) : (
          <span />
        )}
        <button
          type="button"
          className="ob-tip-btn ob-tip-btn--primary"
          onClick={(event) => {
            event.preventDefault()
            event.stopPropagation()
            onNext()
          }}
        >
          {isLastStep ? labels.finish : labels.next}
        </button>
      </div>
    </div>
  )
}
